import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import Authenticator from './components/Authenticator/Authenticator.js'

import { PersistGate } from 'redux-persist/es/integration/react'
import {HashRouter} from 'react-router-dom';

import configureStore from './store/configureStore';
import {setClientPath} from './actions/clientPath'
// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import '../scss/style.scss'
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss'
import 'react-table/react-table.css'
import 'spinkit/css/spinkit.css';
import 'babel-polyfill';
require('es6-promise').polyfill();
require('isomorphic-fetch');

const store = configureStore();
// -- set URL
const url = window.location.host.split(':');

if(url[0] == 'localhost') {
	//store.store.dispatch(setClientPath('http://localhost'));
	store.store.dispatch(setClientPath('http://local.mijndp.nl'));
} else {
	store.store.dispatch(setClientPath('https://' + window.location.host));
}

ReactDOM.render((

	<Provider store={store.store}>
		<PersistGate
		persistor={store.persistor}>
			<HashRouter>
				<Authenticator />
			</HashRouter>
		</PersistGate>
	</Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js